"use strict";
const SHAPE_LIST = "https://raw.githubusercontent.com/protofire/token-list/refs/heads/main/tokenList.json";
export const DEFAULT_INACTIVE_LIST_URLS = [];
export const DEFAULT_ACTIVE_LIST_URLS = [SHAPE_LIST];
export const DEFAULT_LIST_OF_LISTS = [...DEFAULT_ACTIVE_LIST_URLS];
